const pageTitleClass = "font-myriad text-base font-regular text-black-primary md:text-2xl select-none";
const cardTitle = "font-myriad text-lg font-regular text-black-80 select-none";

export const ThemeText = {
    pageTitleClass,
    cardTitle
}